/**
 * Simple API/Service to fetch Home1 page data
 * @module Home1-Service
 */

import { TypeLandingPage } from "../app/@types/pageTypes";
import { publicUrlFor } from "../globals/common-functions";

/**
 * API URL 
 * Here we are fetching data from local JSON
 */
const _URL = publicUrlFor("data/data.json");

/**
 * Getting all data stuff for Template's Home1 page
 * 
 * @param {Function} completion Callback function to return data on fetch success
 */


export async function getHomeLanding(completion: Function) {
    fetch(_URL)
        .then(response => response.json())
        .then(json => completion(transformToHomeLaning(json["landingpage"])))
        .catch(error => console.error(error));
}

/**
 * Function produces data object for Home1 using raw JSON data
 * @param {object} rawData raw JSON object
 * @returns Object of type Home1
 */
const transformToHomeLaning = (rawData: any): TypeLandingPage => {
    // auto type casting
    var _home1: TypeLandingPage = {};
    _home1.slider = rawData["sectionSlider"]
    _home1.clients = rawData["sectionClients"]
    _home1.about = rawData["sectionAbout"]
    _home1.whatWeDo = rawData["sectionWhatWeDo"]
     _home1.services = rawData["sectionServices"]
    _home1.faq = rawData["sectionFAQ"]
    _home1.about2 =  rawData["sectionAbout2"]
    _home1.blogs = rawData["sectionBlog"]
    return _home1;
}


